<template>
  <router-view></router-view>
</template>

<script>
import { differenceInHours } from 'date-fns';

export default {
  name: 'AdminLayout',
  async mounted() {
    if (!this?.$auth?.user?.twoFaVerified) {
      this.$router.push({ name: 'UserTwoFactorVerification' });
    }
    if (this.$auth?.user?.twoFaVerifiedTS
      && differenceInHours(
        new Date(this.$auth?.user?.serverTime),
        new Date(this.$auth?.user?.twoFaVerifiedTS),
      ) > 24
    ) {
      this.$router.push({ name: 'UserTwoFactorVerification' });
    }
  },
};
</script>
